import { Banner } from '@shopify/polaris'

const FreeTrialBanner = ({ trialExpired, setTrialExpired }) => {
  return trialExpired === 2 ? (
    <Banner title="Free Trial Ending Soon!" tone="info" onDismiss={() => setTrialExpired(null)}>
      <p>
        Your trial period will end in 2 days. To avoid being charged, please
        downgrade to the Free plan before the trial ends.
      </p>
    </Banner>
  ) : null
}

export default FreeTrialBanner
